import React from "react";
import { motion } from "framer-motion";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import "../App.css";

const projectList = [
  {
    title: "AI PRD Generator",
    company: "React, Node.js, MongoDB, Pinecone",
    description: "Advanced system to generate Product Requirement Documents from transcripts using an automated LLM data pipeline.",
    responsibilities: "Designed ingestion → processing → retrieval pipeline and integrated LLM APIs for automated generation.",
    github: "https://github.com/Adarsh09675"
  },
  {
    title: "E-Commerce Web Application",
    company: "Java, Spring Boot, JPA, MySQL",
    description: "Full-stack application featuring secure authentication, product catalogs, and order management systems.",
    responsibilities: "Developed REST APIs, implemented secure backend logic, and optimized MySQL database operations.",
    github: "https://github.com/Adarsh09675"
  },
  {
    title: "Travel Story Manager",
    company: "MERN Stack",
    description: "Full-stack application for sharing travel experiences with JWT authentication and responsive UI.",
    responsibilities: "Developed RESTful APIs, implemented secure authentication, and optimized MongoDB queries.",
    github: "https://github.com/Adarsh09675"
  },
  {
    title: "Home-Rental-App",
    company: "MERN Stack",
    description: "Platform for booking stays with advanced search filters and real-time booking status.",
    responsibilities: "Designed dynamic stay listing modules and integrated secure payment gateways.",
    github: "https://github.com/Adarsh09675"
  },
  {
    title: "Smart Contact Manager",
    company: "Java Spring Boot",
    description: "Efficient contact management system with secure user profiles and cloud storage integration.",
    responsibilities: "Built backend with Spring Boot and designed relational schema in MySQL.",
    github: "https://github.com/Adarsh09675"
  },
  {
    title: "Secured File Storage",
    company: "React & Node.js",
    description: "Cloud-based service for encrypted file storage and multi-user access control.",
    responsibilities: "Implemented file encryption logic and managed S3 storage buckets.",
    github: "https://github.com/Adarsh09675"
  },
  {
    title: "Driver Drowsiness Detection",
    company: "Python & OpenCV",
    description: "Real-time fatigue detection system using facial landmarks and eye aspect ratio analysis.",
    responsibilities: "Developed computer vision algorithms and integrated alert mechanisms.",
    github: "https://github.com/Adarsh09675"
  },
  {
    title: "Flipkart Web Scraper",
    company: "Node.js & Playwright",
    description: "Automated tool for extracting product details, prices, and reviews from e-commerce sites.",
    responsibilities: "Handled dynamic content loading and implemented rate-limiting bypass.",
    github: "https://github.com/Adarsh09675"
  }
];

function Projects() {
  return (
    <div>
      <h2 className="section-title text-center mb-5">Key Projects</h2>

      <div className="row g-4">
        {projectList.map((project, index) => (
          <div key={index} className="col-md-6">
            <div className="card-custom h-100 d-flex flex-column">
              <div className="d-flex justify-content-between align-items-start mb-2">
                <h4 className="text-main mb-0">{project.title}</h4>
                {project.github && (
                  <a 
                    href={project.github} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-accent fs-5 hover-scale"
                    title="View Code on GitHub"
                  >
                    <FaGithub />
                  </a>
                )}
              </div>
              <p className="small text-accent mb-3">{project.company}</p>
              <p className="small text-dim mb-4">{project.description}</p>
              <div className="mt-auto pt-3 border-top border-secondary border-opacity-25">
                <p className="small mb-0 text-dim">
                  <strong className="text-main">Role:</strong> {project.responsibilities}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
